import UserPaymentsData from './UserPaymentsData';

export default UserPaymentsData;


// WEBPACK FOOTER //
// ./resources/assets/js/components/UserPaymentsData/index.js